import './bottomMenu.css'

import classNames from 'classnames'
import SearchIcon from 'icons/Search'
import PropTypes from 'prop-types'
import React from 'react'

import Box from '@mui/material/Box'

const BottomMenu = ({ isOpenSearch, isRankingsPath, onHome, onRankings, openSearch }) => {
  const searchClassName = classNames('search-icon icon cursor-pointer', { 'icon-active': isOpenSearch })
  const homeClassName = classNames('fm fm-home cursor-pointer', { active: !isRankingsPath && !isOpenSearch })
  const rankingsClassName = classNames('fm fm-ranking cursor-pointer', { active: isRankingsPath && !isOpenSearch })

  return (
    <div data-html2canvas-ignore="true" className="bottom-menu">
      <Box className={homeClassName} onClick={onHome} />

      <SearchIcon className={searchClassName} onClick={openSearch} />

      <Box className={rankingsClassName} onClick={onRankings} />
    </div>
  )
}

BottomMenu.propTypes = {
  changeDates: PropTypes.func,
  isRankingsPath: PropTypes.bool,
  onHome: PropTypes.func,
  onRankings: PropTypes.func,
  openSearch: PropTypes.func,
}

export default BottomMenu
